import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CancelIcon from '@material-ui/icons/Cancel'
import { Chip } from '@mui/material'


export default function CustomChip({ enabled, ...rest }) {
  return <Chip
    color={enabled ? 'primary' : 'default'}
    icon={enabled ? <CheckCircleIcon /> : <CancelIcon />}
    variant={enabled ? 'default' : 'outlined'}
    sx={{ position: 'relative' }}
    {...rest} 
  />
}